module.exports = __webpack_public_path__ + "static/img/product-bg-1.3c4d559.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-bg-1.png
// module id = PEcE
// module chunks = 0